module.exports = __webpack_public_path__ + "static/media/vamp_Defeat.6e6ebef9.png";